import { useState, useEffect, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import {
  FaCloudUploadAlt,
  FaSave,
  FaDownload,
  FaTrashAlt,
} from "react-icons/fa";
import "./AssinaturaUpload.css";

const AssinaturaUpload = ({
  title = "ASSINATURA (PDF / FUSION)",
  fusionId = "",
  identificador = "",
  nomeArquivo,
  onChangeFusionId,
  onUpload,
  onDownload,
  onSave,
  uploading = false,
  downloading = false,
  saving = false,
  fileName = "",
  hasFile = false,
  onClearFile,
  showSaveButton = true,
}) => {
  const fileInputRef = useRef(null);
  const [localName, setLocalName] = useState("");

  useEffect(() => {
    if (fileName) setLocalName(fileName);
  }, [fileName]);

  const pickFile = () => fileInputRef.current?.click();

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setLocalName(file.name);
      onUpload?.(file);
    }
    e.target.value = "";
  };

  const clearFile = () => {
    setLocalName("");
    onClearFile?.();
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const hasAnyFile = hasFile || !!localName;
  const shownName = fileName || localName;

  return (
    <section className="card shadow-sm p-4 mb-4 assu-card">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h5 className="fw-bold text-uppercase m-0">{title}</h5>

        <div className="assu-actions d-flex align-items-center flex-wrap gap-2">
          <input
            ref={fileInputRef}
            type="file"
            accept="application/pdf"
            className="d-none"
            onChange={onFileChange}
            data-testid="assu-file-input"
          />

          {!hasAnyFile && (
            <button
              type="button"
              className="btn-primario btn-acao d-flex align-items-center gap-2"
              onClick={pickFile}
              disabled={uploading}
              title="Selecionar PDF"
            >
              <FaCloudUploadAlt size={14} />
              {uploading ? "Enviando..." : "Selecionar PDF"}
            </button>
          )}

          {showSaveButton && (
            <button
              type="button"
              className="btn-primario btn-acao d-flex align-items-center gap-2"
              onClick={onSave}
              disabled={saving}
              title="Enviar assinatura"
            >
              <FaSave size={14} />
              {saving ? "Enviando..." : "Enviar assinatura"}
            </button>
          )}
        </div>
      </div>

      <div className="assu-body">
        <Form.Group className="assu-fusion" controlId="assu-fusion-id">
          <Form.Label>Código Fusion</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ex.: DA.000000"
            value={fusionId}
            onChange={(e) => onChangeFusionId?.(e.target.value)}
            className="assu-fusion-input"
            maxLength={20}
          />

          {(identificador || hasAnyFile) && (
            <div className="d-flex align-items-center justify-content-between mt-2 p-2 border rounded bg-light">
              <small className="text-muted m-0">
                {shownName
                  ? `Arquivo: ${shownName}`
                  : `Nome: ${nomeArquivo || "-"}`}
              </small>

              <div className="d-flex align-items-center gap-2">
                {!!identificador && (
                  <button
                    type="button"
                    className="btn-primario btn-acao btn-sm d-flex align-items-center gap-2"
                    onClick={() => onDownload?.(identificador)}
                    disabled={downloading}
                  >
                    <FaDownload size={12} />
                    {downloading ? "Baixando..." : "Download"}
                  </button>
                )}

                <button
                  type="button"
                  className="btn-primario btn-acao btn-sm d-flex align-items-center gap-2"
                  onClick={pickFile}
                  disabled={uploading}
                  title="Trocar arquivo"
                >
                  <FaCloudUploadAlt size={12} />
                  {uploading ? "Enviando..." : "Trocar"}
                </button>

                <Button
                  type="button"
                  variant="danger"
                  className="btn-acao btn-sm d-flex align-items-center gap-2"
                  onClick={clearFile}
                  disabled={uploading || saving || downloading}
                  title="Remover arquivo"
                >
                  <FaTrashAlt size={12} />
                  Remover
                </Button>
              </div>
            </div>
          )}
        </Form.Group>
      </div>
    </section>
  );
};

export default AssinaturaUpload;
